import { TableCell, TableContainer, TableHead, TableRow,Table, TableBody } from '@mui/material'
import React from 'react'
import { useTheme } from '../Context/ThemeContext'
import { useNavigate } from 'react-router-dom';

 const ResultTable = ({data}) => {
   const {theme}=useTheme()

    const styleCell={
        color:theme.titleColor,
        textAlign:'center'
    }
    const navigate = useNavigate()
    const goback =()=>{
      navigate("/")
    }

  return (
    <div className='table'>
      <TableContainer><h4 className='table-name'>Your all time Results</h4>
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell style={styleCell}>
                        WPM
                    </TableCell>
                    <TableCell style={styleCell}>
                    Accuracy
                    </TableCell>
                    <TableCell style={styleCell}>
                    Characters
                    </TableCell>
                    <TableCell style={styleCell}>
                     Date
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
            {
                data.map(i =>(
                    <TableRow>
                        <TableCell style={styleCell}>
                        {i.wpm}
                        </TableCell>
                        <TableCell style={styleCell}>
                        {i.Accuracy}
                        </TableCell>
                        <TableCell style={styleCell}>
                        {i.Characters}
                        </TableCell>
                        <TableCell style={styleCell}>
                        {i.timeStamp.toDate().toLocaleString()}
                        </TableCell>
                    </TableRow>
                    ))
            }
            </TableBody>
        </Table>
        <div className='back' onClick={goback}>Back</div>
      </TableContainer>
    </div>
  )
}
export default ResultTable